import * as Sentry from "@sentry/react";
import PropTypes from "prop-types";

import ErrorFallback from "./ErrorFallback.jsx";

const LwcErrorBoundary = ({
	children,
	customFallbackComponent
}) => (

	<Sentry.ErrorBoundary fallback={customFallbackComponent ? customFallbackComponent : ErrorFallback}>
		{children}
	</Sentry.ErrorBoundary>
);

LwcErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired,
	customFallbackComponent: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.node
	])
};

LwcErrorBoundary.defaultProps = {
	customFallbackComponent: false
};

export default LwcErrorBoundary;
